<template>
  <div class="page_wrapper container-fluid enterprise_area">
    <div class="row profile_header page_header enterprise_header">
      <enterprises-intern-header />
    </div>
    <div class="row enterprise_content">
      <enterprises-intern-student-list-content />
    </div>
  </div>
</template>
<script>
import EnterprisesInternHeader from '~components/pages/enterprises/intern/InternHeader'
import EnterprisesInternStudentListContent from '~components/pages/enterprises/intern/InternStudentListContent'
export default {
  middleware: ['check-auth', 'enterprise-auth'],
  name: 'EnterprisesInternStudentList',
  routerName: 'EnterprisesInternIntern-record',
  components: {
    EnterprisesInternHeader,
    EnterprisesInternStudentListContent
  }
}
</script>
